export const KEYS = {
  STORAGE_COLLECTION_SAMPLE_PCD_DOWNLOADED:
    'STORAGE_COLLECTION_SAMPLE_PCD_DOWNLOADED',
  STORAGE_COLLECTION_LATEST_BUCKET: 'STORAGE_COLLECTION_LATEST_BUCKET',
  STORAGE_COLLECTION_LATEST_DIR_KEY: 'STORAGE_COLLECTION_LATEST_DIR_KEY',
};
